import { doc, setDoc } from 'firebase/firestore';
import { ICurrentActivitySetting } from '../../providers/settings/currentActivitySettingsProvider';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description persists the users current activity setting
 * @param settings
 */
export const saveCurrentActivity = async (
  setting: ICurrentActivitySetting
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${user.id}/settings/currentActivity`
    ),
    setting,
    { merge: true }
  );
};
